import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ScrollToTop } from "./lib/hooks";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { StickyCallButton } from "./components/StickyCallButton";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ChatWidget } from "./components/ChatWidget";
import HomePage from "./pages/Home";
import HomeEsPage from "./pages/HomeEs";
import ServicesPage from "./pages/Services";
import ServiceDetailPage from "./pages/ServiceDetail";
import AboutPage from "./pages/About";
import GalleryPage from "./pages/Gallery";
import ContactPage from "./pages/Contact";
import EstimatePage from "./pages/Estimate";
import EstimateEsPage from "./pages/EstimateEs";
import BlogPage from "./pages/Blog";
import BlogPostPage from "./pages/BlogPost";
import PrivacyPage from "./pages/Privacy";
import TermsPage from "./pages/Terms";
import NonDiscriminationPage from "./pages/NonDiscrimination";
import AccessibilityPage from "./pages/Accessibility";
import SafetyPage from "./pages/Safety";
import GovernmentContractsPage from "./pages/GovernmentContracts";
import AdminPage from "./pages/Admin";
import NotFoundPage from "./pages/NotFound";
import { AreaPage, ServicePageEs, AreaPageEs } from "./pages/LocalPages";

const SiteLayout = () => (
  <>
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
    <StickyCallButton />
    <WhatsAppButton />
    <ChatWidget />
  </>
);

export const AppRoutes = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/es" element={<HomeEsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/areas/:slug" element={<AreaPage />} />
        <Route path="/es/services/:slug" element={<ServicePageEs />} />
        <Route path="/es/areas/:slug" element={<AreaPageEs />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/estimate" element={<EstimatePage />} />
        <Route path="/es/estimate" element={<EstimateEsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/non-discrimination" element={<NonDiscriminationPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/government-contracts" element={<GovernmentContractsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
